import axios from 'axios';
import { ElMessage } from 'element-plus';

// 创建Axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api',
  timeout: 15000,
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对于blob类型的响应，直接返回完整响应对象
    if (response.config.responseType === 'blob') {
      return response;
    }
    
    // 处理204 No Content响应
    if (response.status === 204) {
      return { code: 200, message: '操作成功' };
    }
    
    const res = response.data;

    // 处理token失效情况
    if (res.code === 401 || res.errno === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      ElMessage.error(res.message || '登录已过期，请重新登录');
      // 跳转到登录页面
      window.location.href = '/login';
      return Promise.reject(new Error(res.message || '登录已过期'));
    }

    // 处理wangEditor格式响应（errno: 0表示成功）
    if (res.errno !== undefined) {
      if (res.errno === 0) {
        return res;
      } else {
        ElMessage.error(res.message || '请求失败');
        return Promise.reject(new Error(res.message || '请求失败'));
      }
    }

    // 处理success字段格式的响应（Laravel后端常用格式）
    if (res.success !== undefined) {
        if (res.success) {
            return res;
        } else {
            ElMessage.error(res.message || '请求失败');
            return Promise.reject(new Error(res.message || '请求失败'));
        }
    }

    // 根据后端返回的code判断请求是否成功
    if (![200, 201].includes(res.code)) {
      ElMessage.error(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    }

    return res;
  },
  error => {
    console.error('响应错误:', error);
    
    // 处理HTTP 401状态码
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      const errorMessage = error.response.data?.message || '登录已过期，请重新登录';
      ElMessage.error(errorMessage);
      // 跳转到登录页面
      window.location.href = '/login';
    } else {
      ElMessage.error(error.response?.data?.message || '网络错误');
    }
    
    return Promise.reject(error);
  }
);

export default service;
